import type { FaireProductEntity } from "../../entity_types/product";

export const p_959rkh99g4: FaireProductEntity = {
  token: "p_959rkh99g4",
  type: "product",
  name: "Body Bar - Incendier",
  brandToken: "b_phyk4zwbt3",
  brandName: "Mienne",
  imageUrl:
    "https://cdn.faire.com/fastly/bfc38dedf864c76f97a7d14c023077797e375ea510ba274766fe47432837feee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c7ac495060afb1feafac743a4e7cb735b69f1187bd421726f972447dba01e34.jpeg",
    "https://cdn.faire.com/fastly/8e993b16c0ab324ab0b3e6085aef51794af057cdc24e94580e67153faa46eafd.jpeg",
  ],
  priceDollars: 12.25,
  description:
    "A French-milled bar that gently cleanses while softening and conditioning the skin. Sculptural in form and sensorial in function, its creamy lather is powered by biodegradable surfactants, ultra-nourishing Shea Butter, and Glycerin, while mood-shifting Adaptogens and two signature scents heighten connection through the senses.\n\n",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:32:42.995Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
